@import '../../style/index';

:host {
  display: block;
  margin-top: var(--spacings-xl);

  rcm-column {
    --columnGap: var(--spacings-s);

    @include large-up() {
      --columnGap: var(--spacings-xl);
    }
  }

  .description {
    @include copy-secondary;

    margin-top: rem-calc(12px);
    max-width: rem-calc(752px);
    color: legacy-color-theme(light, color-text--secondary);

    @include large-up {
      max-width: rem-calc(880px);
    }

    @include xlarge-up {
      max-width: rem-calc(960px);
    }
  }

  .copyright {
    @include copy-footnotes;

    margin-top: rem-calc(4px);
    color: legacy-color-theme(light, color-text--secondary);
  }
}
